import React from 'react';
import { Container } from 'reactstrap';
import NegotiationList from './components/NegotiationList';

const NegotiationPage = () => {
  document.title = 'Negotiation';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <NegotiationList
            endpoint='/negotiation'
            detailBasePath='/apps-negotiation/dtl'
            listPath='/apps-negotiation/view'
            mode='buyer'
            title='NEGOTIATION'
            breadcrumbLabel='Negotiation'
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NegotiationPage;
